import { motion } from "framer-motion";

const MILESTONES = [
  { year: "2015", title: "Tirupati Engineering Works established", tag: "Origin" },
  { year: "2016", title: "Forging unit launched · IATF 16949 certified", tag: "Capability" },
  { year: "2017", title: "Export operations commenced", tag: "Global" },
  { year: "2019", title: "Tirupati Autocomp Industrees established", tag: "Group" },
  { year: "2020", title: "UK export operations commenced", tag: "Global" },
  { year: "2021", title: "Second Forging Hammer (Press) installed", tag: "Capability" },
  { year: "2023", title: "In-house Welding & Fabrication facility established", tag: "Capability" },
  { year: "2024", title: "In-house Painting & Silver Plating facility established", tag: "In-house" },
  { year: "2025", title: "Quality Standard Room with CMM established", tag: "Quality" },
  { year: "2026", title: "Startup of Tirupati Global Sourcing Company (TGSC)", tag: "Global" },
];

export default function Milestones() {
  return (
    <section
      id="milestones"
      data-testid="milestones-section"
      className="relative py-24 lg:py-28 bg-brand-navy text-white overflow-hidden"
    >
      <div className="absolute inset-0 bp-grid opacity-25 pointer-events-none" />
      <div className="absolute -top-32 right-0 h-80 w-80 rounded-full bg-brand-earth/15 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-32 left-0 h-80 w-80 rounded-full bg-brand-orange/10 blur-3xl pointer-events-none" />

      <div className="container-x relative">
        <div className="grid lg:grid-cols-12 gap-10 mb-14">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-5">
              <span className="divider-rule" />
              <span className="eyebrow !text-white/80">Milestones of Excellence</span>
            </div>
            <h2 className="font-heading font-extrabold text-3xl sm:text-4xl lg:text-5xl text-white tracking-tight leading-[1.05]">
              A decade of engineering.
              <br />
              <span className="text-brand-orange">Built milestone by milestone.</span>
            </h2>
          </div>
          <div className="lg:col-span-5 text-white/75 leading-relaxed">
            From establishing the manufacturing unit in 2015 to becoming a
            vertically integrated group exporting to USA, UK, Europe and the
            Middle East — every year has added new capability and new capacity.
          </div>
        </div>

        {/* Horizontal scrollable timeline */}
        <div className="relative">
          <div className="absolute left-0 right-0 top-9 h-px bg-white/15" />
          <div
            className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 xl:grid-cols-12 gap-6 lg:gap-3 relative"
          >
            {MILESTONES.map((m, i) => (
              <motion.div
                key={m.year}
                initial={{ opacity: 0, y: 18 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.15 }}
                transition={{ duration: 0.5, delay: (i % 12) * 0.05 }}
                data-testid={`milestone-${m.year}`}
                className="relative pt-16"
              >
                <div className="absolute top-7 left-0 flex flex-col items-center w-full">
                  <span className="h-4 w-4 bg-brand-orange step-active rounded-full" />
                </div>
                <div className="text-center">
                  <div className="font-heading font-extrabold text-2xl text-brand-orange">
                    {m.year}
                  </div>
                  <div className="mt-2 text-[10px] uppercase tracking-[0.22em] text-white/55">
                    {m.tag}
                  </div>
                  <div className="mt-2 text-xs text-white/85 leading-snug">
                    {m.title}
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
